import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotComicsGrid() {
  const hotComics = featuredComics.slice(0, 6);

  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-800 bg-accent-100 rounded-full mb-4 font-label">
            热门推荐
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
            本周热门
            <br />
            韩国漫画
          </h2>
        </div>

        {/* Comic Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {hotComics.map((comic) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Cover */}
              <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 虫虫漫画网完整版免费阅读`}
                  title={`${comic.title} - 下拉式韩国漫画免费阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Status badge */}
                <div className="absolute top-3 left-3">
                  <span
                    className={`px-2.5 py-1 text-xs font-medium rounded-full backdrop-blur-sm ${
                      comic.status === '已完结'
                        ? 'bg-accent-500/85 text-foreground-950'
                        : 'bg-primary-500/85 text-background-50'
                    }`}
                  >
                    {comic.status}
                  </span>
                </div>
                {/* Rating */}
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-foreground-950/60 backdrop-blur-sm rounded-full">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span className="text-xs text-background-50 font-medium">{comic.rating}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{comic.author}</span>
                  <span className="text-foreground-200">·</span>
                  <span>{comic.chapters}话</span>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {comic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All */}
        <div className="mt-10 text-center">
          <Link
            to="/category/korea"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}